<script setup lang="ts">
defineProps<{ filled?: boolean }>();
</script>

<template>
	<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
		<path
			d="M12 20.64s-6.2-4.5-9-9.2C1.4 8.24 2.6 4.44 6.2 3.54c2.2-.6 4.4.3 5.8 2.2 1.4-1.9 3.6-2.8 5.8-2.2 3.6.9 4.8 4.7 3.2 7.9-2.8 4.7-9 9.2-9 9.2Z"
			:fill="filled ? 'currentColor' : 'none'"
			:stroke="filled ? 'none' : 'currentColor'"
			stroke-width="1.8"
			stroke-linejoin="round"
			stroke-linecap="round"
		/>
	</svg>
</template>
